export interface SARadioStorage {
  id: number;
  name: string;
  frequency: string;
  plan: 'free' | 'pro' | 'premium';
  storageUsedGB: number;
  storageTotalGB: number;
  videosGB: number;
  fotosGB: number;
  audiosGB: number;
  logoUrl: string;
  city: string;
  country: string;
}

export interface SAStorageKPI {
  totalUsedGB: number;
  totalCapacityGB: number;
  videosGB: number;
  fotosGB: number;
  audiosGB: number;
}

export const saStorageKPIs: SAStorageKPI = {
  totalUsedGB: 381.45,
  totalCapacityGB: 8000,
  videosGB: 310.58,
  fotosGB: 49.93,
  audiosGB: 20.94,
};

export const saRadiosStorage: SARadioStorage[] = [
  {
    id: 1, name: 'Radio Nueva Actitud', frequency: '94.70 RFW', plan: 'pro',
    storageUsedGB: 3.2, storageTotalGB: 50,
    videosGB: 1.8, fotosGB: 0.9, audiosGB: 0.5,
    logoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20circular%20design%2C%20warm%20golden%20amber%20colors%2C%20sound%20wave%20symbol%2C%20clean%20corporate%20style%2C%20abstract%20geometric%20mark%2C%20high%20contrast%20professional%20brand%20identity&width=120&height=120&seq=sa-storage-logo-1&orientation=squarish',
    city: 'Santa Rosa', country: 'Estados Unidos',
  },
  {
    id: 2, name: 'Radio Ritmo Latino', frequency: '101.30 RFW', plan: 'free',
    storageUsedGB: 0.98, storageTotalGB: 1,
    videosGB: 0.25, fotosGB: 0.25, audiosGB: 0.48,
    logoUrl: 'https://readdy.ai/api/search-image?query=Latin%20radio%20station%20logo%20design%2C%20vibrant%20warm%20colors%20red%20orange%20coral%2C%20tropical%20music%20theme%2C%20circular%20emblem%2C%20modern%20flat%20design%2C%20clean%20background%20professional%20brand%20mark&width=120&height=120&seq=sa-storage-logo-2&orientation=squarish',
    city: 'San José', country: 'Costa Rica',
  },
  {
    id: 3, name: 'Radio Éxitos TV', frequency: '94.70 RFW', plan: 'premium',
    storageUsedGB: 18.7, storageTotalGB: 500,
    videosGB: 12.4, fotosGB: 3.6, audiosGB: 2.7,
    logoUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20station%20logo%2C%20bold%20modern%20design%2C%20metallic%20silver%20and%20crimson%20red%20accents%2C%20broadcast%20tower%20icon%2C%20sleek%20corporate%20identity%2C%20high%20contrast%20minimalist%20style&width=120&height=120&seq=sa-storage-logo-3&orientation=squarish',
    city: 'Ciudad de México', country: 'México',
  },
  {
    id: 4, name: 'Radio Fiesta Mix', frequency: '88.50 RFW', plan: 'free',
    storageUsedGB: 0.55, storageTotalGB: 1,
    videosGB: 0.15, fotosGB: 0.15, audiosGB: 0.25,
    logoUrl: 'https://readdy.ai/api/search-image?query=Energetic%20radio%20station%20logo%2C%20neon%20pink%20and%20electric%20blue%20colors%2C%20party%20music%20theme%2C%20circular%20abstract%20design%2C%20modern%20vibrant%20brand%20identity%20for%20youth%20audience&width=120&height=120&seq=sa-storage-logo-4&orientation=squarish',
    city: 'Buenos Aires', country: 'Argentina',
  },
  {
    id: 5, name: 'Radio Pirata FM', frequency: '99.90 RFW', plan: 'free',
    storageUsedGB: 0.95, storageTotalGB: 1,
    videosGB: 0.32, fotosGB: 0.32, audiosGB: 0.31,
    logoUrl: 'https://readdy.ai/api/search-image?query=Rebel%20radio%20station%20logo%2C%20dark%20skull%20and%20crossbones%20radio%20theme%2C%20edgy%20underground%20design%2C%20black%20and%20crimson%20colors%2C%20grunge%20aesthetic%20brand%20identity&width=120&height=120&seq=sa-storage-logo-5&orientation=squarish',
    city: 'Lima', country: 'Perú',
  },
  {
    id: 6, name: 'Radio Sonora Digital', frequency: '103.70 RFW', plan: 'pro',
    storageUsedGB: 47.8, storageTotalGB: 50,
    videosGB: 28.5, fotosGB: 12.8, audiosGB: 6.5,
    logoUrl: 'https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%2C%20warm%20terracotta%20and%20sand%20colors%2C%20acoustic%20guitar%20and%20sombrero%20elements%2C%20circular%20traditional%20modern%20fusion%20design%2C%20professional%20brand%20identity&width=120&height=120&seq=sa-storage-logo-6&orientation=squarish',
    city: 'Hermosillo', country: 'México',
  },
  {
    id: 7, name: 'Radio Stereo Visión', frequency: '96.10 RFW', plan: 'premium',
    storageUsedGB: 45.2, storageTotalGB: 500,
    videosGB: 22.8, fotosGB: 14.1, audiosGB: 8.3,
    logoUrl: 'https://readdy.ai/api/search-image?query=Urban%20radio%20station%20logo%2C%20graffiti%20street%20art%20style%2C%20vibrant%20purple%20and%20lime%20green%20colors%2C%20city%20skyline%20element%2C%20modern%20hip%20hop%20culture%20brand%20identity&width=120&height=120&seq=sa-storage-logo-7&orientation=squarish',
    city: 'Medellín', country: 'Colombia',
  },
  {
    id: 8, name: 'Radio Clásica FM', frequency: '88.90 RFW', plan: 'premium',
    storageUsedGB: 8.1, storageTotalGB: 500,
    videosGB: 4.1, fotosGB: 2.6, audiosGB: 1.4,
    logoUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20radio%20station%20logo%2C%20sophisticated%20gold%20and%20ivory%20palette%2C%20violin%20and%20orchestra%20elements%2C%20refined%20circular%20emblem%2C%20luxury%20brand%20identity%20for%20cultured%20audience&width=120&height=120&seq=sa-storage-logo-8&orientation=squarish',
    city: 'Santiago', country: 'Chile',
  },
  {
    id: 9, name: 'Radio Urbana 101', frequency: '101.10 RFW', plan: 'free',
    storageUsedGB: 0.35, storageTotalGB: 1,
    videosGB: 0.08, fotosGB: 0.08, audiosGB: 0.19,
    logoUrl: 'https://readdy.ai/api/search-image?query=Street%20culture%20radio%20logo%2C%20bold%20graffiti%20typography%2C%20urban%20concrete%20texture%2C%20orange%20and%20black%20color%20scheme%2C%20edgy%20underground%20brand%20identity%20for%20hip%20hop%20station&width=120&height=120&seq=sa-storage-logo-9&orientation=squarish',
    city: 'Caracas', country: 'Venezuela',
  },
  {
    id: 10, name: 'Radio Élite Digital', frequency: '107.50 RFW', plan: 'premium',
    storageUsedGB: 87.3, storageTotalGB: 500,
    videosGB: 42.8, fotosGB: 26.5, audiosGB: 18.0,
    logoUrl: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%2C%20professional%20serious%20design%2C%20navy%20blue%20and%20silver%20metallic%2C%20globe%20and%20microphone%20elements%2C%20authoritative%20corporate%20brand%20identity%20for%20journalism&width=120&height=120&seq=sa-storage-logo-10&orientation=squarish',
    city: 'Madrid', country: 'España',
  },
  {
    id: 11, name: 'La Voz del Llano', frequency: '92.30 RFW', plan: 'free',
    storageUsedGB: 0.99, storageTotalGB: 1,
    videosGB: 0.45, fotosGB: 0.30, audiosGB: 0.24,
    logoUrl: 'https://readdy.ai/api/search-image?query=Folk%20radio%20station%20logo%2C%20traditional%20rural%20design%2C%20earth%20tones%20green%20and%20brown%2C%20harp%20and%20landscape%20elements%2C%20rustic%20circular%20brand%20identity%20for%20regional%20music&width=120&height=120&seq=sa-storage-logo-11&orientation=squarish',
    city: 'Villavicencio', country: 'Colombia',
  },
  {
    id: 12, name: 'Radio Universo Online', frequency: '95.80 RFW', plan: 'free',
    storageUsedGB: 0.15, storageTotalGB: 1,
    videosGB: 0.05, fotosGB: 0.05, audiosGB: 0.05,
    logoUrl: 'https://readdy.ai/api/search-image?query=Indie%20radio%20station%20logo%2C%20minimalist%20cosmic%20design%2C%20deep%20purple%20and%20teal%20space%20colors%2C%20planet%20and%20sound%20wave%20elements%2C%20modern%20alternative%20brand%20identity%20for%20young%20creatives&width=120&height=120&seq=sa-storage-logo-12&orientation=squarish',
    city: 'Montevideo', country: 'Uruguay',
  },
  {
    id: 13, name: 'Radio Festival TV', frequency: '100.20 RFW', plan: 'pro',
    storageUsedGB: 49.2, storageTotalGB: 50,
    videosGB: 28.7, fotosGB: 13.1, audiosGB: 7.4,
    logoUrl: 'https://readdy.ai/api/search-image?query=Festival%20radio%20station%20logo%2C%20vibrant%20confetti%20colorful%20design%2C%20orange%20magenta%20and%20yellow%2C%20stage%20lights%20elements%2C%20energetic%20circular%20brand%20identity%20for%20live%20events&width=120&height=120&seq=sa-storage-logo-13&orientation=squarish',
    city: 'Quito', country: 'Ecuador',
  },
  {
    id: 14, name: 'Radio Brisas del Mar', frequency: '89.70 RFW', plan: 'pro',
    storageUsedGB: 15.6, storageTotalGB: 50,
    videosGB: 8.4, fotosGB: 4.8, audiosGB: 2.4,
    logoUrl: 'https://readdy.ai/api/search-image?query=Tropical%20radio%20station%20logo%2C%20ocean%20breeze%20theme%2C%20turquoise%20and%20sandy%20beige%20colors%2C%20palm%20tree%20and%20sun%20elements%2C%20relaxed%20circular%20brand%20identity%20for%20beach%20vibes&width=120&height=120&seq=sa-storage-logo-14&orientation=squarish',
    city: 'Acapulco', country: 'México',
  },
  {
    id: 15, name: 'Radio Juventud Stereo', frequency: '104.50 RFW', plan: 'free',
    storageUsedGB: 0.08, storageTotalGB: 1,
    videosGB: 0.03, fotosGB: 0.03, audiosGB: 0.02,
    logoUrl: 'https://readdy.ai/api/search-image?query=Youth%20radio%20station%20logo%2C%20bright%20cheerful%20design%2C%20neon%20cyan%20and%20hot%20pink%20colors%2C%20emoji%20and%20digital%20elements%2C%20modern%20circular%20brand%20identity%20for%20teen%20audience&width=120&height=120&seq=sa-storage-logo-15&orientation=squarish',
    city: 'Ciudad de Panamá', country: 'Panamá',
  },
  {
    id: 16, name: 'Radio Folclor Andino', frequency: '91.40 RFW', plan: 'free',
    storageUsedGB: 0.97, storageTotalGB: 1,
    videosGB: 0.38, fotosGB: 0.38, audiosGB: 0.21,
    logoUrl: 'https://readdy.ai/api/search-image?query=Andean%20folk%20radio%20logo%2C%20traditional%20mountain%20design%2C%20warm%20earth%20tones%20terracotta%20and%20ochre%2C%20quena%20flute%20and%20mountain%20elements%2C%20circular%20cultural%20brand%20identity&width=120&height=120&seq=sa-storage-logo-16&orientation=squarish',
    city: 'Cusco', country: 'Perú',
  },
  {
    id: 17, name: 'Radio Retro Hits', frequency: '98.60 RFW', plan: 'pro',
    storageUsedGB: 48.9, storageTotalGB: 50,
    videosGB: 24.8, fotosGB: 16.2, audiosGB: 7.9,
    logoUrl: 'https://readdy.ai/api/search-image?query=Retro%20radio%20station%20logo%2C%20vintage%20vinyl%20record%20design%2C%20warm%20sepia%20and%20mustard%20colors%2C%20nostalgic%2080s%20aesthetic%2C%20circular%20classic%20brand%20identity%20for%20oldies%20station&width=120&height=120&seq=sa-storage-logo-17&orientation=squarish',
    city: 'Asunción', country: 'Paraguay',
  },
  {
    id: 18, name: 'Radio TechBeats', frequency: '106.20 RFW', plan: 'pro',
    storageUsedGB: 3.5, storageTotalGB: 50,
    videosGB: 1.8, fotosGB: 1.2, audiosGB: 0.5,
    logoUrl: 'https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20logo%2C%20futuristic%20cyberpunk%20design%2C%20dark%20background%20with%20neon%20green%20and%20electric%20blue%2C%20digital%20waveform%2C%20sleek%20modern%20brand%20identity%20for%20tech%20music&width=120&height=120&seq=sa-storage-logo-18&orientation=squarish',
    city: 'San Salvador', country: 'El Salvador',
  },
  {
    id: 19, name: 'Radio Deportiva Total', frequency: '93.80 RFW', plan: 'pro',
    storageUsedGB: 43.8, storageTotalGB: 50,
    videosGB: 22.3, fotosGB: 14.1, audiosGB: 7.4,
    logoUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%2C%20dynamic%20energetic%20design%2C%20bold%20red%20and%20white%20colors%2C%20soccer%20ball%20and%20microphone%20elements%2C%20circular%20action%20brand%20identity%20for%20sports%20fans&width=120&height=120&seq=sa-storage-logo-19&orientation=squarish',
    city: 'Guadalajara', country: 'México',
  },
  {
    id: 20, name: 'Radio Gospel Internacional', frequency: '87.90 RFW', plan: 'free',
    storageUsedGB: 0.72, storageTotalGB: 1,
    videosGB: 0.20, fotosGB: 0.20, audiosGB: 0.32,
    logoUrl: 'https://readdy.ai/api/search-image?query=Gospel%20radio%20station%20logo%2C%20spiritual%20serene%20design%2C%20soft%20gold%20and%20white%20colors%2C%20dove%20and%20light%20rays%20elements%2C%20circular%20peaceful%20brand%20identity%20for%20Christian%20music&width=120&height=120&seq=sa-storage-logo-20&orientation=squarish',
    city: 'Miami', country: 'Estados Unidos',
  },
];

export const planLabel: Record<string, string> = {
  free: 'Básico',
  pro: 'Pro',
  premium: 'Premium',
};